import LicenseFeatureGroupRegistryFeatureRow from "@/v2-backoffice-client/license/featureGroup/compose/registry/LicenseFeatureGroupRegistryFeatureRow"
import LicenseFeatureGroupRegistryPaneSkeleton from "@/v2-backoffice-client/license/featureGroup/compose/registry/LicenseFeatureGroupRegistryPaneSkeleton"
import type { FeatureGroupPickedLike } from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.compose.utils"
import {
  REGISTRY_PANE_CLASS,
  type RegistryRow,
} from "@/v2-backoffice-client/license/featureGroup/compose/registry/license.featureGroup.registry.utils"

export type LicenseFeatureGroupRegistryFeaturesPaneProps = {
  rows: readonly RegistryRow[]
  /** Nothing narrows the registry yet: neither a type nor a filter. */
  hasScope: boolean
  isLoading: boolean
  /** Rows of several types are listed together: name the type on each. */
  showsType: boolean
  /** The browse read caps its rows; say so when the cap is hit. */
  rowLimit: number
  entitledTypeCodes: ReadonlySet<number>
  featureGroupName: string
  isPicked(code: string): boolean
  wasPicked(code: string): boolean
  onSetPicked(
    features: readonly FeatureGroupPickedLike[],
    picked: boolean,
  ): void
}

// The third column: the features the selection reaches, one row each, or
// the one line that says what to pick first.
function LicenseFeatureGroupRegistryFeaturesPane(
  props: LicenseFeatureGroupRegistryFeaturesPaneProps,
) {
  const { rows, hasScope, isLoading, showsType, rowLimit, ...rowProps } = props

  return (
    <div className={REGISTRY_PANE_CLASS}>
      {!hasScope ? (
        <p className="px-2.5 py-3 text-xs text-muted-foreground">
          Pick a type, or type two letters, to list features.
        </p>
      ) : isLoading && rows.length === 0 ? (
        <LicenseFeatureGroupRegistryPaneSkeleton />
      ) : (
        <ul className="divide-y">
          {rows.map((row) => (
            <LicenseFeatureGroupRegistryFeatureRow
              key={row.Code}
              row={row}
              showsType={showsType}
              {...rowProps}
            />
          ))}
          {rows.length === 0 && !isLoading && (
            <li className="px-2.5 py-3 text-xs text-muted-foreground">
              Nothing matches.
            </li>
          )}
          {rows.length >= rowLimit && (
            <li className="px-2.5 py-2 text-[11px] text-muted-foreground">
              Showing the first {rowLimit} — narrow with a type, a family or the
              filter.
            </li>
          )}
        </ul>
      )}
    </div>
  )
}

export default LicenseFeatureGroupRegistryFeaturesPane
